<template>
  <div
    class="bg"
    ref="myChart"
    :id="id"
    :style="{ width: '100%', height: height }"
  ></div>
</template>
<script>
import requesApi from "../../../views/predict/index";
import uuid from "uuid/v1";
export default {
  data() {
    return {
      id: uuid()
    };
  },
  props: {
    height: {
      type: String,
      default: "200px"
    },
    kid: {
      type: String,
      default: ""
    },
    datas: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {},
  mounted() {
    this.drawLine(this.datas);
  },
  methods: {
    drawLine(obj) {
      var app = {};
      var posList = [
        "left",
        "right",
        "top",
        "bottom",
        "inside",
        "insideTop",
        "insideLeft",
        "insideRight",
        "insideBottom",
        "insideTopLeft",
        "insideTopRight",
        "insideBottomLeft",
        "insideBottomRight"
      ];
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: posList.reduce(function(map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };
      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [
              {
                label: labelOption
              },
              {
                label: labelOption
              },
              {
                label: labelOption
              },
              {
                label: labelOption
              }
            ]
          });
        }
      };
      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: "",
        fontSize: 16,
        rich: {
          name: {}
        }
      };

      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(this.id));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid:{
          left:'30px',
          right:'30px',
          top:'30px',
          bottom:'30px'
        },
        legend: {
          top:'0',
          data: ["金额"]
        },
        yAxis: {
          type: "value"
        },
        // color:['#000','#fff'],
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: obj.xData
          }
        ],
        series: [
          {
            name:'金额',
            data: obj[this.kid],
            type: "bar",
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background: #fff;
  border-radius: 4px;
  padding-top: 10px;
}
</style>
